import { Maybe, TrainingCourse } from '@/app/graphql/generated'
import { titles } from '@/app/shared/components/cours-item/contants'
import { ImageLaptopOrange, ImageLaptopPurple } from '@/app/shared/images'

export const getImage = (isIntensive: boolean) => {
  return isIntensive ? ImageLaptopOrange : ImageLaptopPurple
}

export const getTitles = (slug: string) => {
  return titles.find((el) => el.slug === slug)?.text ?? ''
}

export const generateDescription = (data?: Maybe<TrainingCourse>) => {
  return (
    [
      {
        slug: 'course_duration',
        value: data?.course_duration,
      },
      {
        slug: 'schedule',
        value: data?.schedule,
      },
      {
        slug: 'count_of_lessons',
        value: data?.count_of_lessons,
      },
      {
        slug: 'regularity_of_lessons',
        value: data?.regularity_of_lessons,
      },
      {
        slug: 'lesson_duration',
        value: data?.lesson_duration,
      },
    ].filter((el) => !!el.value) ?? []
  )
}

export const colorThemeIcon = (type: string) =>
  `group-hover:${type === 'standard' ? 'text-secondary' : 'text-danger'}`
